import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';


@Injectable()
export class ChildApiService {

    constructor(private http: ApiHttpClient) { }

    public get(memberId: string): Observable<api.OperationPagedResult<camps.ChildModel>> {
        return this.http.get<api.OperationPagedResult<camps.ChildModel>>(`child/${memberId}`, true);
    }
}
